import React from "react";
import styled from "styled-components";
import Img from 'gatsby-image';
import { siteColors } from "../constants/colors";
import breakpoints from "../constants/breakpoints";
import {
  Band,
  BandTextContainer,
  BandTextHeader,
  BandBodyText,
} from "./band";
import { AdaptiveHostedVideo } from "./hosted-video.js";
import { VideoContainer, VideoInnerContainer } from "./ephemeral-video-container.js";

const TextMarginTopAdjustmentContainer = styled.div`
   margin-top: -7.0em;

  @media (max-width: ${ breakpoints.desktopSmallHD }px) {
   margin-top: 2.0em;
  }
`;

const EditBand = (props) => (
  <Band background={siteColors.darkest} reverse>
        <VideoContainer>
        <VideoInnerContainer>
        <AdaptiveHostedVideo url="https://www.youtube.com/embed/ROFLjfplLuc?si=ej42r8wK5xDrXrUB" title="Edit Dense Animation Data" />
        </VideoInnerContainer>
        </VideoContainer>
    <BandTextContainer>
        <TextMarginTopAdjustmentContainer>
      <BandTextHeader>
        Edit dense motion data
      </BandTextHeader>
      <BandBodyText>
        It doesn’t matter whether your motion was created by hand or comes
    from mocap data, simulation, or AI; The Ephemeral Animation System
    will let you edit it without the need for key reduction, animation layers,
    or baking.
        </BandBodyText>

        <BandBodyText>
    Among other things, this allows polishing motion without using tangent
    handles or a graph editor! It’s almost like sculpting with motion.
      </BandBodyText>
        </TextMarginTopAdjustmentContainer>
    </BandTextContainer>
  </Band>
);

export default EditBand;
